var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-bottom": "100px" } },
    [
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c("ModalItem", {
            attrs: {
              header: _vm.header,
              icon: "icon-add",
              "entity-name": _vm.entityName
            },
            on: { addItem: _vm.addItem }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "chartDataRangeSelector" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.range,
                    expression: "range"
                  }
                ],
                attrs: { id: "rangeDays", name: "range" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.range = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "week" } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("health", "last week")) +
                      "\n\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "month" } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("health", "last month")) +
                      "\n\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "year" } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("health", "last year")) +
                      "\n\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "all" } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("health", "Show all")) +
                      "\n\t\t\t"
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c("table", [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.header, function(h, i) {
                    return _c("th", { key: i, class: { hide: !h.show } }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(h.name) + "\n\t\t\t\t")
                    ])
                  }),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.t("health", "Actions", {})) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.datasets, function(d, i) {
                return _c(
                  "tr",
                  { key: i },
                  [
                    _vm._l(_vm.header, function(h, ii) {
                      return _c(
                        "td",
                        {
                          key: ii,
                          class: { hide: !h.show },
                          style: h.style ? h.style(d[h.columnId]) : "",
                          attrs: { "data-label": h.name }
                        },
                        [
                          _c("div", [
                            h.type === "date" && d[h.columnId]
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("formatMyDate")(d[h.columnId])
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              : h.type === "datetime" && d[h.columnId]
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("formatMyDatetime")(
                                          d[h.columnId]
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              : h.type === "select" &&
                                Number.isInteger(d[h.columnId])
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        h.options &&
                                          h.options[d[h.columnId]] &&
                                          h.options[d[h.columnId]].label
                                          ? h.options[d[h.columnId]].label
                                          : "no label found"
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              : h.type === "multiselect" && d[h.columnId]
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _c(
                                    "ul",
                                    _vm._l(JSON.parse(d[h.columnId]), function(
                                      option,
                                      optionIndex
                                    ) {
                                      return _c("li", { key: optionIndex }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              option ? option : "no label found"
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              : h.type === "longtext" && d[h.columnId]
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s("prefix" in h ? h.prefix : "") +
                                      _vm._s(d[h.columnId]) +
                                      _vm._s("suffix" in h ? h.suffix : "") +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              : h.type === "boolean" && d[h.columnId]
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s("prefix" in h ? h.prefix : "") +
                                      "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        d[h.columnId]
                                          ? "textTrue" in h
                                            ? h.textTrue
                                            : _vm.t("health", "true")
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        !d[h.columnId]
                                          ? "textFalse" in h
                                            ? h.textFalse
                                            : _vm.t("health", "false")
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t" +
                                      _vm._s("suffix" in h ? h.suffix : "") +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              : h.type === "text" && d[h.columnId]
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s("prefix" in h ? h.prefix : "") +
                                      _vm._s(d[h.columnId]) +
                                      _vm._s("suffix" in h ? h.suffix : "") +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              : h.type === "number" && d[h.columnId]
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s("prefix" in h ? h.prefix : "") +
                                      _vm._s(d[h.columnId]) +
                                      _vm._s("suffix" in h ? h.suffix : "") +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              : h.type === "calculate" && d
                              ? _c("div", { staticClass: "wrapper" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s("prefix" in h ? h.prefix : "") +
                                      _vm._s(h.calc(d)) +
                                      _vm._s("suffix" in h ? h.suffix : "") +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "inlineButtons" },
                        [
                          _c("ModalItem", {
                            attrs: {
                              id: i,
                              header: _vm.header,
                              "item-data": d,
                              "input-mode": "edit",
                              "entity-name": _vm.entityName,
                              icon: "icon-rename"
                            },
                            on: { addItem: _vm.updateItem }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "inlineButtons" }, [
                        _c("button", {
                          staticClass: "icon-delete",
                          on: {
                            click: function($event) {
                              return _vm.deleteItem(i)
                            }
                          }
                        })
                      ])
                    ])
                  ],
                  2
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.data.length - _vm.datasets.length > 0
        ? _c("div", { staticClass: "gray" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.n(
                    "health",
                    "%n item is hidden, because it is out of the chosen time range.",
                    "%n items are hidden, because they are out of the chosen time range.",
                    _vm.data.length - _vm.datasets.length,
                    {}
                  )
                ) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.getExportData.length > 0
        ? _c(
            "JsonCSV",
            {
              attrs: { data: _vm.getExportData, name: _vm.entityName + ".csv" }
            },
            [
              _c("button", { staticClass: "export" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.t("health", "Download (CSV)", {})) +
                    "\n\t\t"
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.datasets || (_vm.data.length === 0 && !_vm.loading)
        ? _c(
            "EmptyContent",
            {
              attrs: { icon: "icon-category-monitoring" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "desc",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n\t\t\t" +
                            _vm._s(
                              _vm.t(
                                "health",
                                "Click at the + to add the first data."
                              )
                            ) +
                            "\n\t\t\t"
                        ),
                        _c("ModalItem", {
                          attrs: {
                            header: _vm.header,
                            "entity-name": _vm.entityName,
                            "input-mode": "add",
                            icon: "icon-add"
                          },
                          on: { addItem: _vm.addItem }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                927769004
              )
            },
            [_vm._v("\n\t\tNo data yet\n\t\t")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }